import createSvgIcon from "./utils/create_icon"

const FrameThicknessSmall = createSvgIcon(<path d="M8 6a2 2 0 0 0-2 2v13h2V8h13V6z" fill="currentColor" />, "FrameThicknessSmall")
export default FrameThicknessSmall
